<script>
export default {
    name: 'CommunityMoveInReady',
    props: {
        homes: { type: Array, default: () => ([]) },
        optionsBeds: { type: Array, default: [] },
        optionsBaths: { type: Array, default: [] },
        communityId: { type: Number, default: 0 },
    },
    data: () => ({
        searchParams: new URLSearchParams(),
        now: Date.now(),
        nowPlus1Month: new Date((new Date()).setMonth(new Date().getMonth() + 1)).getTime(),
        nowPlus2Months: new Date((new Date()).setMonth(new Date().getMonth() + 2)).getTime(),
        availabilies: {
            'ready': 'Ready',
            '1-months': '1 Month',
            '2-months': '2 Months',
            '3-months': '3 Months+'
        },
        filters: {
            beds: '',
            baths: '',
            completion: '',
            floorplan: '',
            is_bold_series_home: ''
        },
        /*
        sort: {
            key: '',
            direction: ''
        },
        */
        sortByList: [
            {key: 'availability-ascending', value: 'Availability: Soonest'},
            {key: 'availability-descending', value: 'Availability: Latest'},
            {key: 'price-ascending', value: 'Price: Low to High'},
            {key: 'price-descending', value: 'Price: High to Low'},
            {key: 'sqft-ascending', value: 'Sq. Ft: Low to High'},
            {key: 'sqft-descending', value: 'Sq. Ft: High to Low'},
            {key: 'beds-ascending', value: 'Beds: Low to High'},
            {key: 'beds-descending', value: 'Beds: High to Low'},
            {key: 'baths-ascending', value: 'Baths: Low to High'},
            {key: 'baths-descending', value: 'Baths: High to Low'},
            // {key: 'garage-ascending', value: 'Garages: Low to High'},
            // {key: 'garage-descending', value: 'Garages: High to Low'},
        ],
        sortBy: 'price-ascending'
    }),
    computed: {
        openModal() { return this.$parent.$parent.openModal; },
        // optionsBeds() {
        //     return [...new Set(this.homes.map(home => home.beds))]
        //         .map(o => ({ key: o, value: o }));
        // },
        // optionsBaths() {
        //     return [...new Set(this.homes.map(home => home.baths))]
        //         .map(o => ({ key: o, value: parseFloat(o) }));
        // },
        optionsCompletions() {
            return this.homes
                .map(h => h.availability_date)
                .reduce((result, item) => {
                    const d = new Date(item).getTime();
                    let completion = '';

                    if (d <= this.now) {
                        completion = 'ready';
                    } else if (d > this.now && d <= this.nowPlus1Month) {
                        completion = '1-months';
                    } else if (d > this.now && d <= this.nowPlus2Months) {
                        completion = '2-months';
                    } else if (d > this.nowPlus2Months) {
                        completion = '3-months';
                    }

                    if (!result.includes(completion)) {
                        result.push(completion);
                    }

                    return result;
                }, [])
                .sort()
                .map(c => ({ key: c, value: this.availabilies[c] }));
        },
        optionsFloorplans() {
            let ids = [];
            return this.homes
                .map(h => ({id: h.residence_id, name: h.name }))
                .reduce((result, item) => {
                    if (!ids.includes(item.id)) {
                        ids.push(item.id);
                        result.push({ key: item.id, value: item.name });
                    }
                    return result;
                }, [])
                .sort((a, b) => a.value.localeCompare(b.value));
        },
        filteredHomes() {
            return this.homes.filter(this.filterHome).sort(this.sortHome);
            /*
            return this.sort.key
                ? this.homes.filter(this.filterHome).sort(this.sortHome)
                : this.homes.filter(this.filterHome);
                */
        },
        sort() {
            return this.sortBy ? this.sortBy.split('-')[0] : null;
        },
        sortDirection() {
            return this.sortBy ? this.sortBy.split('-')[1] : null;
        }
    },
    watch: {
        filters: {
            deep: true,
            handler(newFilters) {
                this.setQueryParams(newFilters);
            }
        }
    },
    created() {
        this.searchParams.set('community', this.communityId);
    },
    methods: {
        filterHome(home) {
            let passesFilter = true;

            if (this.filters.beds && home.beds !== this.filters.beds) {
                passesFilter = false;
            }

            if (this.filters.baths && home.baths !== this.filters.baths) {
                passesFilter = false;
            }

            if (this.filters.completion && home.filter_completion !== this.filters.completion) {
                passesFilter = false;
            }

            if (this.filters.floorplan && home.residence_id !== this.filters.floorplan) {
                passesFilter = false;
            }

            if (passesFilter && this.filters.is_bold_series_home && !!home.is_bold_series_home !== this.filters.is_bold_series_home) {
                passesFilter = false;
            }

            return passesFilter;
        },
        /*
        sortHomes(homeA, homeB) {
            const itemA = parseFloat(homeA[this.sort.key]);
            const itemB = parseFloat(homeB[this.sort.key]);
            return this.sort.direction === 'descending'
                ? itemB - itemA
                : itemA - itemB;
        },
        toggleSort(sortBy) {
            this.sort.direction = this.sort.key !== sortBy
                ? 'ascending'
                : this.sort.direction === 'ascending' ? 'descending' : 'ascending';
            this.sort.key = sortBy;
        },
        */
        sortHomeByDate(homeA, homeB, sortDirection) {
            if (!homeA.availability_date && !homeB.availability_date) {
                return 0;
            }
            if (!homeA.availability_date) {
                return 1;
            }
            if (!homeB.availability_date) {
                return -1;
            }
            return sortDirection === 'ascending'
                ? new Date(homeA.availability_date) - new Date(homeB.availability_date)
                : new Date(homeB.availability_date) - new Date(homeA.availability_date);
        },
        /**
         * Sorts 2 homes
         * @param {Object} homeA - The first home item to compare
         * @param {Object} homeB - The second home item to compare
         * @returns {Array} sorted items
         */
        sortHome(homeA, homeB) {
            const sort = this.sort;

            if(sort === 'availability') {
                return this.sortHomeByDate(homeA, homeB, this.sortDirection);
            }
            let a = homeA[sort] ? parseFloat(homeA[sort]) : 0;
            let b = homeB[sort] ? parseFloat(homeB[sort]) : 0;

            // If homes are equal, sort secondarily by price unless
            // primary sort is price
            if (sort !== 'price' && a === b) {
                a = homeA.price ? parseFloat(homeA.price) : 0;
                b = homeB.price ? parseFloat(homeB.price) : 0;
                // Secondary price sorting will always be ascending
                return a === 0 ? 1 : (b === 0 ? -1 : a - b);
            }

            // Put all 0 or empty properties last
            if (this.sortDirection === 'ascending' && a === 0) {
                return 1;
            }
            if (this.sortDirection === 'ascending' && b === 0) {
                return -1;
            }
            if (this.sortDirection === 'descending' && a === 0) {
                return -1;
            }
            if (this.sortDirection === 'descending' && b === 0) {
                return 1;
            }

            return this.sortDirection === 'ascending' ? a - b : b - a;
        },
        resetFilters() {
            this.filters.beds = '';
            this.filters.baths = '';
            this.filters.completion = '';
            this.filters.floorplan = '';
            this.sortBy = 'price-ascending';
        },
         setQueryParams(filters){

            Object.entries(filters).forEach(([key, val]) => {
                let newKey = key;
                if (key === 'beds') {
                    newKey = 'bedrooms';
                }
                if (key === 'baths') {
                    newKey = 'bathrooms';
                }
                if (val) {
                    this.searchParams.set(newKey, val);

                } else {
                    this.searchParams.delete(newKey);
                }
            });

        
        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/community-move-in-ready.vue